import { utilLiveChatLoaded, utilOpenLiveChat } from "../helpers/util";

const livechatOpenTriggerAttrib = "js-livechat-trigger-open";

export const liveChat = () => {
    const chatOpenTriggers = document.querySelectorAll(`[${livechatOpenTriggerAttrib}]`);

    chatOpenTriggers.forEach((trigger) => {
        const triggerAction = trigger.getAttribute(livechatOpenTriggerAttrib);

        if (triggerAction) {
            trigger.addEventListener(triggerAction, (e:Event) => {
                e.preventDefault();
                if (utilLiveChatLoaded()) {
                    utilOpenLiveChat();
                }
            });
        }
    });
};